import type React from 'react';
import { useEffect, useMemo, useState } from 'react';

import { FeaturevisorProvider } from '@featurevisor/react';
import { createInstance } from '@featurevisor/sdk';
import { getEnvType } from 'envConfig';
import Loader from 'components/technical/Loader/Loader';
import { useAuth } from 'components/management/NewAuthProvider';

export function FeatureFlagsProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  // biome-ignore lint/suspicious/noExplicitAny:
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const env = getEnvType();
  const url =
    env === 'prod' || env === 'localhost-prod'
      ? 'https://orbit.genieai.fr/api/release/production'
      : env === 'dev'
        ? 'https://orbit.genieai.fr/api/release/staging'
        : '/orbit-flags';

  useEffect(() => {
    setIsLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then(setData)
      .finally(() => setIsLoading(false));
  }, [url]);

  const f = useMemo(() => {
    if (!data) return null;
    return createInstance({
      datafile: data,
      context: {
        userId: user?.cognitoUsername,
        user: {
          id: user?.cognitoUsername,
          email: user?.email,
        },
      },
    });
  }, [data, user?.cognitoUsername, user?.email]);

  if (isLoading) return <Loader />;
  if (!f) return <p>No FF Datafile</p>;

  return <FeaturevisorProvider instance={f}>{children}</FeaturevisorProvider>;
}
